export default "__VITE_ASSET__DCn4yJ5A__"